import { combineReducers } from 'redux';
import { reducer as app } from './AppRedux';
import { reducer as auth } from './AuthRedux';
import { reducer as pay } from './PayRedux';
import { reducer as receipt } from './ReceiptRedux';
import { reducer as order } from './OrderRedux';
import { reducer as promotion } from './PromotionRedux';

const reducers = combineReducers({ app, auth, pay, receipt, order, promotion });

export default reducers;
